import PropTypes from 'prop-types'

export default {
  original: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  description: PropTypes.string
}
